module.exports = __webpack_public_path__ + "img/jusbklogo.16d379a4.png";